import { useEffect } from "react";

const SCRIPT_ID = "google-recaptcha-v3";
const HIDE_STYLE_ID = "google-recaptcha-badge-hidden";

/**
 * Lazily injects the Google reCAPTCHA v3 script into <head> when the calling
 * component mounts, and keeps the floating badge visible only for the
 * lifetime of that component. The reCAPTCHA SDK caches internally, so we
 * do NOT remove the script on unmount — we hide the badge with a scoped
 * stylesheet instead. Result: the badge appears on /login and /register
 * only, never on landing / dashboard / pricing / etc.
 */
export default function useRecaptcha() {
  useEffect(() => {
    const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
    if (!siteKey) return undefined;

    // Inject the script once (idempotent across route changes).
    if (!document.getElementById(SCRIPT_ID)) {
      const s = document.createElement("script");
      s.id = SCRIPT_ID;
      s.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
      s.async = true;
      s.defer = true;
      document.head.appendChild(s);
    }

    // Reveal the badge on this page: remove any previous hide-style.
    const hide = document.getElementById(HIDE_STYLE_ID);
    if (hide) hide.remove();

    return () => {
      // Hide the badge again on unmount so it doesn't leak to other pages.
      if (!document.getElementById(HIDE_STYLE_ID)) {
        const style = document.createElement("style");
        style.id = HIDE_STYLE_ID;
        style.textContent = ".grecaptcha-badge { visibility: hidden !important; }";
        document.head.appendChild(style);
      }
    };
  }, []);
}
